module.exports = __webpack_public_path__ + "static/media/question_list.79613532.svg";